<template>
  <div class="form-group">
    <slot name="label">
      <label v-if="label" class="control-label" :class="{ required: isRequired }">
        {{label}}
      </label>
      <img v-if="tooltip" v-tooltip="{ content: tooltip, offset: 0}" src="@/assets/static/img/tooltip/tooltip.svg" alt="..."/>
    </slot>
    <textarea 
      :value="value"
      :rows="rows" 
      class="form-control border-input"
      :placeholder="placeholder"
      :maxlength="maxLength"
      @input="$emit('input',$event.target.value)"
      v-bind="$attrs">
    </textarea>
    <slot name="textLimit">
      <div v-if="maxLength" class="max-length">
        {{ remainingCount }}
      </div>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'fg-textarea',
    props: {
      label: String,
      tooltip: String,
      placeholder: String,
      value: String,
      maxLength: Number,
      rows: Number,
      isRequired: Boolean,
    },
    computed: {
      remainingCount () {
        return this.maxLength - this.value.length
      },
    },
  }
</script>